/**
 * Extract all m_* prefixed params from URLSearchParams.
 * Removes the m_ prefix from keys.
 */
export const extractModalParams = (searchParams: URLSearchParams): Record<string, string> => {
  const params: Record<string, string> = {};
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith('m_')) {
      params[key.slice(2)] = value;
    }
  }
  return params;
};

/**
 * Remove modal and all m_* prefixed params from URLSearchParams.
 * Modifies the searchParams in place.
 */
export const clearModalParams = (searchParams: URLSearchParams): void => {
  searchParams.delete('modal');
  for (const key of [...searchParams.keys()]) {
    if (key.startsWith('m_')) {
      searchParams.delete(key);
    }
  }
};
